import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { CodeExonerationListDto } from '@lexi-clients/lexi';
import { CodeExonerationListResult } from '../models/code-exoneration-list';

@Injectable({
  providedIn: 'root'
})
export class CodeExonerationListService implements IGridService<CodeExonerationListDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<CodeExonerationListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/CodeExonerations/recherche-devexpress`, { params: params });
  }

  getById(codeExonerationId: number): Observable<CodeExonerationListDto> {
    return this.http.get<any>(`${this.baseUrl}/api/CodeExonerations/${codeExonerationId}`);
  }

  post(valeur: CodeExonerationListDto): Observable<any> {
    return null;
  }

  put(valeur: CodeExonerationListDto): Observable<any> {
    return null;
  }

  delete(valeur: CodeExonerationListDto): Observable<any> {
    return null;
  }
}
